export const SEO_CONFIG = {
  product: {
    title: "Product SEO",
    apiEndpoint: "seo/product",
    entityEndpoint: "/config/product/dropdown",
    entityLabel: "Product",
    entityIdField: "product_id",
    navigationPath: "/portal/products-seo",
  },
  category: {
    title: "Category SEO",
    apiEndpoint: "seo/category",
    entityEndpoint: "/config/category/dropdown",
    entityLabel: "Category",
    entityIdField: "category_id",
    navigationPath: "/portal/categories-seo",
  },
  subcategory: {
    title: "Subcategory SEO",
    apiEndpoint: "seo/subcategory",
    entityEndpoint: "/config/subcategory/dropdown",
    entityLabel: "Subcategory",
    entityIdField: "subcategory_id",
    navigationPath: "/portal/subcategories-seo",
  },
  "main-category": {
    title: "Main Category SEO",
    apiEndpoint: "seo/main-category",
    entityEndpoint: "/config/main-category/dropdown",
    entityLabel: "Main Category",
    entityIdField: "main_category_id",
    navigationPath: "/portal/main-categories-seo",
  },
  "static-page": {
    title: "Static Page SEO",
    apiEndpoint: "seo/static-page",
    entityEndpoint: null,
    entityLabel: "Static Page",
    entityIdField: "id",
    navigationPath: "/portal/static-pages-seo",
    isStatic: true,
    staticPages: ["Home", "About", "Contact", "Terms-Policy"],
  },
};

// Common field configurations
export const COMMON_FIELDS = {
  META_ROBOTS_OPTIONS: [
    { value: "index,follow", label: "Index, Follow" },
    { value: "noindex,follow", label: "No Index, Follow" },
    { value: "index,nofollow", label: "Index, No Follow" },
    { value: "noindex,nofollow", label: "No Index, No Follow" },
  ],

  SITEMAP_FREQUENCY_OPTIONS: [
    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
    { value: "yearly", label: "Yearly" },
  ],

  SITEMAP_PRIORITY_OPTIONS: [
    { value: 0.1, label: "0.1" },
    { value: 0.2, label: "0.2" },
    { value: 0.3, label: "0.3" },
    { value: 0.4, label: "0.4" },
    { value: 0.5, label: "0.5" },
    { value: 0.6, label: "0.6" },
    { value: 0.7, label: "0.7" },
    { value: 0.8, label: "0.8" },
    { value: 0.9, label: "0.9" },
    { value: 1.0, label: "1.0" },
  ],
};
